export default "__VITE_ASSET__DUJnxYWD__"